import { useState } from "react"
import type { ComponentProps } from "react"
import ViewSheet from "@/v2-backoffice-client/components/viewSheet"
import { TooltipButton } from "@/v2-backoffice-client/components/button"
import LicenseAddOnUpsertDialog from "@/v2-backoffice-client/license/addOns/catalog/LicenseAddOnUpsertDialog"
import type { AddOnCatalogFragment } from "@/v2-backoffice-client/license/addOns/catalog/__types__/license.addOn.catalog.fragment"

export type LicenseAddOnViewToolbarProps = ComponentProps<"div"> & {
  addOn: AddOnCatalogFragment | null | undefined
}

// Identity/scope edit only (same dialog as the board's row menu). What the
// package unlocks is the Feature Groups tab's job; granting stays on the
// customer panel where the license context is; retiring stays in the row
// menu next to the list it removes from.
function LicenseAddOnViewToolbar(props: LicenseAddOnViewToolbarProps) {
  const { addOn, ...viewSheetToolbarProps } = props
  const [isEditOpen, setIsEditOpen] = useState(false)
  if (!addOn) return null

  return (
    <ViewSheet.Toolbar {...viewSheetToolbarProps}>
      <TooltipButton
        variant="ghost"
        isStacked
        iconSrc="edit"
        content="Edit the add-on's name, code, description, which license it goes with, or scope — scope locks once customers have it"
        onClick={() => {
          setIsEditOpen(true)
        }}
      >
        Edit
      </TooltipButton>

      <LicenseAddOnUpsertDialog
        addOn={addOn}
        open={isEditOpen}
        onOpenChange={setIsEditOpen}
      />
    </ViewSheet.Toolbar>
  )
}

export default LicenseAddOnViewToolbar
